import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { TopographicLines } from "./TopographicLines";

const stopPositions = [
  { x: 130, y: 116 },
  { x: 356, y: 210 },
  { x: 688, y: 273 },
  { x: 1050, y: 204 }
] as const;

export function Journey() {
  const { messages } = useI18n();

  return (
    <section id="journey" className="journey section" aria-labelledby="journey-title">
      <div className="journey__map">
        <TopographicLines className="journey__contours journey__contours--left" />
        <TopographicLines className="journey__contours journey__contours--right" />
        <div className="shell journey__heading">
          <h2 id="journey-title">{messages.journey.title}</h2>
          <p>{messages.journey.body}</p>
        </div>
        <div className="route-map shell" aria-label={messages.journey.mapLabel}>
          <svg viewBox="0 0 1180 370" role="img" aria-labelledby="route-map-title">
            <title id="route-map-title">{messages.journey.mapTitle}</title>
            <path
              className="route-map__land"
              d="M52 71c90-45 190-35 284-8 66 19 126 14 191 31 80 21 105 78 178 88 91 12 133-51 235-27 57 13 102 45 178 28v115H52Z"
            />
            <path
              className="route-map__route"
              d="M130 116c72 8 77 78 145 74 33-2 44-5 81 20 99 68 166 14 236 46 49 22 58 30 96 17 68-23 104-38 171-23 81 19 121 14 191-46"
            />
            {messages.journey.stops.map((stop, index) => (
              <g
                key={stop.name}
                transform={`translate(${stopPositions[index]?.x ?? 0} ${
                  stopPositions[index]?.y ?? 0
                })`}
              >
                <circle className="route-map__halo" r="14" />
                <circle className="route-map__point" r="6" />
                <text className="route-map__label" y={-24} textAnchor="middle">
                  {stop.name}
                </text>
                <text className="route-map__detail" y={33} textAnchor="middle">
                  {stop.detail}
                </text>
              </g>
            ))}
          </svg>
          <p>{messages.journey.routeNote}</p>
        </div>
      </div>

      <div className="shell market-reality">
        <div>
          <p className="market-reality__number">{messages.journey.signalCount}</p>
          <p>{messages.journey.signalSummary}</p>
        </div>
        <div className="market-reality__copy">
          <h3>{messages.journey.demandTitle}</h3>
          <p>{messages.journey.demandBody}</p>
          <Link className="text-link" to="/#interest">
            {messages.journey.addSignal}
            <ArrowRight className="directional-icon" size={16} aria-hidden="true" />
          </Link>
          <p className="source-note">{messages.journey.sourceNote}</p>
        </div>
      </div>
    </section>
  );
}
